import { PMTiles } from 'pmtiles'
import { MVTLoader } from "@loaders.gl/mvt";
import { _TerrainExtension as TerrainExtension, DataFilterExtension } from "@deck.gl/extensions";
import { linearScale } from "../singleLayer/renderLayerService";
import { TileLayer } from 'deck.gl';
import { parse } from "@loaders.gl/core";
import { hideLoading, showLoading } from "../core/utils";

export function PSInSARLayer(workspace, layerName, is3D, opacity, zoom, dataSource) {
    const domain = [-15, 0, 15]
    const range = [[255, 0, 0], [3, 252, 32], [0, 0, 255]]
    const pmtiles = new PMTiles(dataSource)

    return [
        new TileLayer({
            id: 'PSInsarLayer',
            data: null,
            getTileData: async (tile) => {
                const { x, y, z } = tile.index;
                const res = await pmtiles.getZxy(z, x, y);
                const data = res.data ? new Uint8Array(res.data) : new Uint8Array();
                return parse(data, MVTLoader, {
                    loadOptions: { worker: true },
                    mvt: {
                        coordinates: "wgs84",
                        tileIndex: { x, y, z },
                    },
                });
            },
            tileSize: 512,
            onTileLoad: showLoading,
            onViewportLoad: hideLoading,
            opacity: opacity / 100,
            filled: true,
            stroke: true,
            maxZoom: 15,
            getLineColor: f => linearScale(f.properties.v_los, domain, range),
            getFillColor: f => linearScale(f.properties.v_los, domain, range),
            getLineWidth: 1,
            lineWidthMinPixels: 7.0,
            pickable: true,
            terrainDrawMode: is3D ? 'offset' : '',
            extensions: is3D ? [new TerrainExtension()] : [],
            dataComparator: (a, b) => false
        }),
    ]
}
